import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import styles from "./style";
import OldSearchBox from "./OldSearchBox";
import CustomSearchBox from "./CustomSearchBox";

const Searcher = ({
  wrapperClass,
  placeholder,
  handleOnSubmit,
  handleOnFocus,
  handleOnBlur,
  ariaLabel,
  id}) => {
    
  return (
    <div
      className={`Searcher ${wrapperClass}`}
    >
      <CustomSearchBox
        id={id}
        ariaLabel={ariaLabel}
        placeholder={placeholder}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        autoComplete="off"
        onSubmit={handleOnSubmit}
      />
      {/*useNewSearcher  ? (
        <CustomSearchBox
          id={id}
          aria-label={ariaLabel}
          placeholder={placeholder}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          autoComplete="off"
          onSubmit={handleOnSubmit}
        />
      ) : (
        <OldSearchBox
          id={id}
          aria-label={ariaLabel}
          placeholder={placeholder}
          onFocus={handleOnFocus}
          onBlur={handleOnBlur}
          defaultValue={searcherQuery}
          autoComplete="off"
          onSubmit={handleOnSubmit}
        />
      )*/}
      < style jsx>{styles}</style>
    </div >
  );
};

Searcher.propTypes = {
  wrapperClass: PropTypes.string,
  placeholder: PropTypes.string,
  handleOnSubmit: PropTypes.func.isRequired,
  handleOnChange: PropTypes.func,
  handleOnFocus: PropTypes.func,
  handleOnBlur: PropTypes.func,
  autocomplete: PropTypes.bool,
  id: PropTypes.string,
};

Searcher.defaultProps = {
  wrapperClass: "",
  placeholder: "",
  id: "searcher",
  handleOnChange: () => { },
  handleOnBlur: () => { },
  handleOnFocus: () => { },
  autocomplete: false,
};

export default Searcher;
